import React from 'react';
import { Portlet, PortletBody } from "../../../../partials/content/Portlet";
import PortletSpinner from "../../../../partials/layout/PortletSpinner";
import DataGridBase from "../../../../partials/layout/DataGridBase";
import * as inspectionDefectCrud from '../../../../crud/inspectionDefect.crud';
import { Badge } from "react-bootstrap";
import CustomFieldHelper from "../../_Helpers/CustomFieldHelper"
import { notificationAggregateListTagsFilter, notificationUniqueTagsFilter, notificationUniqueTagsFilterV3 } from "../../../../store/helpers/FilterHelper";
import { withListPageProps } from '../../../../shared/hoc/withListPageProps';
import BaseListPage from '../../_CustomComponents/BaseListPage';


export const getBatchFormFields = (fields, replyFields, intl) => {
    const formFields = [];
    if (fields.Subject.visible) {
        formFields.push({
            caption: fields.Subject.label,
            dataField: 'assistancetestserchdefect',
            required: fields.Subject.required,
            dataType: 'string',
        })
    }
    if (fields.Type.visible) {
        formFields.push({
            caption: fields.Type.label,
            dataField: 'replycomment',
            required: fields.Type.required,
            dataType: 'list',
            options: {
                dataSource: fields.Type.clauses,
                valueExpr: 'display',
                displayExpr: 'display'
            }
        })
    }
    if (fields.ResponseRequiredDate.visible) {
        formFields.push({
            caption: fields.ResponseRequiredDate.label,
            dataField: 'replyrequireddatedisplay',
            required: fields.ResponseRequiredDate.required,
            dataType: 'date',
        })
    }


    if (fields.Details.visible) {
        formFields.push({
            caption: fields.Details.label,
            dataField: 'inspectiondetails',
            required: fields.Details.required,
            dataType: 'long-string',
        })
    }


    if (replyFields.ReplyStatus.visible) {
        formFields.push({
            caption: replyFields.ReplyStatus.label,
            dataField: 'replystatus',
            required: replyFields.ReplyStatus.required,
            dataType: 'list',
            options: {
                dataSource: replyFields.ReplyStatus.replyOptions,
                valueExpr: 'field',
                displayExpr: 'display'
            },
            isReplyField: true
        })
    }

    if (replyFields.ReplyComment.visible) {
        formFields.push({
            caption: replyFields.ReplyComment.label,
            dataField: 'replyaction',
            required: replyFields.ReplyComment.required,
            dataType: 'long-string',
            isReplyField: true
        })
    }

    return formFields;
}

class NotifyListPage extends BaseListPage {
    constructor(props) {
        super(props);
        const { replyFields } = this.props.workflowItem;
        if (this.props.workflowItem.replyEnabled && replyFields?.ReplyStatus?.replyOptions) {
            this.replyOptionsQA = replyFields.ReplyStatus.replyOptions.reduce((obj, item) => ({ ...obj, [item.field]: item.display }), {});
        }

        this.notificationsTagsEnabled = process.env.REACT_APP_COMMUNICATION_TAG_ENABLED === 'true' && props.contract.specifictags?.length > 0;
        this.notificationsRelsEnabled = process.env.REACT_APP_COMMUNICATION_REL_ENABLED === 'true';
        this.customFields = [];
        if (props.customFields) {
            if (props.customFields.COMMUNICATION && props.customFields.COMMUNICATION.length > 0) {
                this.customFields.push(...(props.customFields.COMMUNICATION.filter(cf => cf.includelisting)));
            }
            if (props.customFields.REPLY && props.customFields.REPLY.length > 0) {
                this.customFields.push(...(props.customFields.REPLY.filter(cf => cf.includelisting)));
            }
        }
        this.batchFormFields = getBatchFormFields(this.props.workflowItem.fields, this.props.workflowItem.replyFields, this.props.intl);

        this.state = {
            notifications: null,
            tags: null
        };
    }
    componentDidMount() {
        super.componentDidMount();
        this.fetchNotifications2();
    }

    fetchNotifications = async () => {
        try {
            const { companyid, projectid, contractid } = this.props.contract;
            const { data: responseObj } = await inspectionDefectCrud.getInspectionsReduced(companyid, projectid, contractid, this.props.notificationType, this.props.accessibleWfIds)
            let listData = notificationAggregateListTagsFilter(responseObj.aggregatelist);
            listData = (this.props.workflowItem.userFilters.mainNotice.viewDraftAllowed === true) ?
                listData :
                listData.filter(ntf => ntf.showtasknotification === 1);

            let tagFilters = notificationUniqueTagsFilter(responseObj.uniquetags);
            this.setState({ notifications: listData, tags: tagFilters });
        } catch (error) {
            this.props.enqueueSnackbar('Failed to load communications', { variant: 'error', });
        }
    }

    fetchNotifications2 = async () => {
        try {
            const { companyid, projectid, contractid } = this.props.contract;
            const { data: responseObj } = await inspectionDefectCrud.getInspectionsReducedV2(
                companyid,
                projectid,
                contractid,
                this.props.notificationType,
                this.props.workflowItem.userFilters.mainNotice.viewDraftAllowed,
                this.props.accessibleWfIds);
            let notifications = CustomFieldHelper.MapDataListCustomFieldsToObjectPropertiesV2(responseObj);
            let tagFilters = notificationUniqueTagsFilterV3(this.props.communicationTags);
            this.setState({ notifications, tags: tagFilters });
        } catch (error) {
            console.log(error)
            this.props.enqueueSnackbar('Failed to load communications', { variant: 'error', });
        }
    }

    onTableSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData.length > 0) {
            const data = selectedRowsData[0];
            const url = this.calculateUrl(data, true);
            this.props.navigate(url);
        }
    }
    calculateUrl = (rowData, skipHostUrl) => {
        return (skipHostUrl ? '' : process.env.PUBLIC_URL) + this.props.workflowItem.paths.basePath + rowData.inspectiondefectid;
    }
    renderStatusColumn = (cellInfo) => {
        let badgeVariant = 'secondary';
        switch (cellInfo.data.replystatus) {
            case 'Awaiting Acceptance':
                badgeVariant = 'warning';
                break;
            case 'Not Communicated':
                badgeVariant = 'secondary';
                break;
            case 'Not Accepted':
            case 'NOT_ACCEPTED':
            case 'NOT_ACCEPTED_RESUBMIT':
                badgeVariant = 'danger';
                break;
            case 'Communicated':
            case 'Accepted':
            case 'Reply Not Required':
            case 'Accepted with comments':
            case 'ACCEPT':
            case 'ACCEPT_WITH_COMMENTS':
            case 'NO_REPLY_REQUIRED':
                badgeVariant = 'success';
                break;
            default:
                break;
        }
        const displayText = this.calculateReplyStatusValue(cellInfo.data);
        return (<Badge variant={badgeVariant}>{displayText}</Badge>);
    }
    calculateReplyStatusValue = (rowData) => {
        if (this.replyOptionsQA && this.replyOptionsQA.hasOwnProperty(rowData.replystatus)) {
            return this.replyOptionsQA[rowData.replystatus];
        }
        else {
            return this.props.intl.formatMessage({ id: 'OPTIONS.STATUS.' + rowData.replystatus });
        }
    }
    render() {
        if (!this.state.notifications) {
            return (<PortletSpinner />);
        }

        const columns = [
            { resource: "GENERAL.FORMS.FIELD.ID", dataField: "referenceid", dataType: 'string', renderReferenceidLink: true },
            { resource: "GENERAL.FORMS.FIELD.SUBJECT", dataField: "assistancetestserchdefect" },
            { resource: "GENERAL.FORMS.FIELD.TYPE", dataField: "replycomment" },
            { caption: this.props.notificationType === 'Instruction' ? this.props.intl.formatMessage({ id: 'GENERAL.FORMS.FIELD.INSTRUCTED_DATE' }) : this.props.intl.formatMessage({ id: 'GENERAL.FORMS.FIELD.NOTIFIED_DATE' }), dataField: "notificationdate", dataType: 'date' },
            { caption: this.props.notificationType === 'Instruction' ? this.props.intl.formatMessage({ id: 'GENERAL.FORMS.FIELD.INSTRUCTED_BY' }) : this.props.intl.formatMessage({ id: 'GENERAL.FORMS.FIELD.NOTIFIED_BY' }), dataField: "communicatedby" },
            { resource: "GENERAL.FORMS.FIELD.STATUS", dataField: "replystatus", cellRender: this.renderStatusColumn, calculateCellValue: this.calculateReplyStatusValue },
            { resource: "GENERAL.FORMS.FIELD.DETAILS", dataField: "inspectiondetails", isHtml: true },
            { resource: "GENERAL.FORMS.FIELD.LINK", dataField: "url", calculateCellValue: this.calculateUrl, visible: false, showInColumnChooser: false },
            { resource: "PROJECT.FIELD.CODE", dataField: "projectcode", visible: false },
            { resource: "PROJECT.FIELD.NAME", dataField: "project", visible: false },
            { resource: "GENERAL.FORMS.FIELD.CREATED_BY", dataField: "createby", visible: false },
            { resource: "GENERAL.FORMS.FIELD.DRAFT_NOTIFIED_TO", dataField: "lastdraftednotifiedtoname", visible: false },

        ];
        if (this.props.workflowItem.replyEnabled) {
            columns.push(
                { resource: "GENERAL.FORMS.FIELD.REPLY_REQUIRED", dataField: "replyrequireddate", dataType: 'date' },
                { resource: "GENERAL.FORMS.FIELD.REPLY_DRAFT_BY", dataField: "draftreplyby", visible: false },
                { resource: "GENERAL.FORMS.FIELD.REPLIED_BY", dataField: "inspectionby", visible: false },
                { resource: "GENERAL.FORMS.FIELD.REPLY_DATE", dataField: "replydate", dataType: 'date', visible: false },
                { resource: "GENERAL.FORMS.FIELD.REPLY_COMMENTS", dataField: "replyaction", isHtml: true, visible: false },
                { resource: "GENERAL.FORMS.REPLING_PARTY", dataField: "replyingparty", lookup: { dataSource: this.props.contractTemplate.parties.options, valueExpr: 'id', displayExpr: 'display' }, visible: false },
                { resource: "GENERAL.FORMS.FIELD.REPLY_CREATED_BY", dataField: "replycreatebyname", visible: false },
                { resource: "GENERAL.FORMS.FIELD.REPLY_DRAFT_NOTIFIED_TO", dataField: "lastreplydraftednotifiedtoname", visible: false },
            );
        }
        if (this.props.workflowItem.assetFieldsEnabled) {
            columns.push(
                { resource: "GENERAL.FORMS.FIELD.ASSET_NAME", dataField: "assetname", visible: false },
                { resource: "GENERAL.FORMS.FIELD.ASSET_TYPE", dataField: "assettype", visible: false },
            );
        }
        if (this.notificationsTagsEnabled) {
            columns.push(
                { resource: "GENERAL.FORMS.FIELD.PORTFOLIO", dataField: "tags_portfolio", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tags.PortfolioFilter } },
                { resource: "GENERAL.FORMS.FIELD.PROGRAMME", dataField: "tags_programme", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tags.ProgrammeFilter } },
                { resource: "GENERAL.FORMS.FIELD.PROJECT", dataField: "tags_project", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tags.ProjectFilter } },
                { resource: "GENERAL.FORMS.FIELD.OTHER", dataField: "tags_other", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tags.OtherFilter } }
            )
        }
        if (this.notificationsRelsEnabled) {
            columns.push(
                { resource: "GENERAL.FORMS.TAB_RELATIONS", dataField: "relatednotices", visible: false },
            )
        }
        columns.push(...CustomFieldHelper.MapCustomFieldsToDataGridColumns(this.customFields));

        return (
            <Portlet>
                <PortletBody>
                    <DataGridBase
                        version="1"
                        //BATCH OPS
                        batchOperations={true}
                        batchFormFields={this.batchFormFields}
                        batchImportEndpoint={inspectionDefectCrud.importInspectionDefects}
                        batchDeleteEndpoint={inspectionDefectCrud.deleteInspectionDefectDrafts}
                        batchCommunicateEndpoint={inspectionDefectCrud.communicateInspectionDefectDrafts}
                        onBatchRecordsUpdated={this.fetchNotifications}
                        customFields={this.props.customFields}
                        //BATCH OPS
                        title={this.props.intl.formatMessage({ id: 'GENERAL.REGISTER.TITLE2' }, { ITEM_NAME: this.props.workflowItem.pageTitle })}
                        workflowItem={this.props.workflowItem}
                        createPath={this.props.workflowItem.userFilters.mainNotice.createAllowed ? this.props.workflowItem.paths.createPath : null}
                        name={this.props.workflowItem.pageTitle}
                        dataSource={this.state.notifications}
                        keyExpr="inspectiondefectid"
                        onSelectionChanged={this.onTableSelectionChanged}
                        hoverStateEnabled={true}
                        rowAlternationEnabled={false}
                        columns={columns}
                    />
                </PortletBody>
            </Portlet>
        );
    }
}



export default withListPageProps(NotifyListPage);
